
const en = {
    mainTitle: '404 Not Found Page',
    backLinkName: 'To the home page ', 
}

const rus = {
    mainTitle: '404 Страница не найдена',
    backLinkName:'Вернуться на главную страницу ',
}

const hebrew = {
    mainTitle: '404 – הדף לא נמצא',
    backLinkName: 'חזרה לדף הבית',
}

const choose = { en, rus, hebrew };

export default choose;